<template>
    <div class="identity-page">
    <h2>{{ heading }}</h2>
    <p>{{ body }}</p>
    </div>
  </template>

  <script>
  export default {
  name: "IdentityPage",
  props: {
    heading: {
      type: String,
      default: 'Your Trusted Leader for Roofing in Niles, Michigan'
    },
    body: {
      type: String,
      default: "Homes Roofing Co aims to be the trusted roofing expert for homeowners and businesses across the Great Lakes State. Our experienced team of roofing professionals is dedicated to providing the highest quality in residential and commercial roof repairs, replacements, and free inspections. We prioritize excellence and customer satisfaction, ensuring a smooth and hassle-free experience from start to finish. Reach out today for your free, no-obligation estimate!"
    }
  }
    }
</script>  
  
  <style scoped>
  .identity-page {
    font-family: 'Roboto', sans-serif;
  color: #ffffff;
  line-height: 1.6;
  text-shadow: 2px 2px 0px #000000;
  letter-spacing: 2px;
  background: transparent;
  padding: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }

  </style>